import { html, View } from 'rune-ts';
import klass from './TermsModal.module.scss';
import { createAgreeModal } from '../../../../../../../services/MarppleShop/shared/client/agreeModal';

class PersonalInfoOutsourcingTerms extends View {
  override template() {
    return html`
      <div class="${klass.root}">
        <section>
          <p>
            1. 회사는 이용자의 개인정보를 본 개인정보처리방침에서 고지한 범위 내에서 사용하며, 이용자의 사전
            동의 없이 동 범위를 초과하여 이용하거나 이용자의 개인 정보를 제3자에게 제공하지 않습니다. 다만,
            관련 법령에 의하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관 등에 개인정보를
            제공하여야 하는 경우는 예외로 합니다. 회사의 서비스 이행을 위하여 개인정보를 제3자에게 제공하고
            있는 경우는 다음과 같습니다.
          </p>
        </section>
        <section class="${klass.mb16}">
          <table class="${klass.terms_table}">
            <thead>
              <tr>
                <th>제공받는 자</th>
                <th>제공목적</th>
                <th>개인정보의 항목</th>
                <th>개인정보의 보유 및 이용기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <ul>
                    <li>- 8개 카드사 (국민, 비씨, 롯데, 삼성, NH농협, 현대, 신한, KEB하나)</li>
                    <li>- 4개 시중은행 (신한, SC제일, 씨티, 하나)</li>
                    <li>- 8개 특수은행 (농협, 기업, 국민, 저축, 수협, 신협, 우체국, 새마을금고)</li>
                    <li>- 7개 지방은행 (대구, 부산, 경남, 광주, 전북, 조흥, 제주)</li>
                    <li>- 1개 전업카드사 (우리)</li>
                    <li>
                      - 12개 VAN사 (금민, KIS정보통신, NICE정보통신, LG히씨피, 한국신용카드결제,
                      퍼스트데이터코리아, (주)케이에스넷, 스마트VAN, 제이티넷, KICC, 스마트로,
                      NHN한국사이버결제)
                    </li>
                  </ul>
                </td>
                <td>신용카드 결제</td>
                <td>
                  가맹점명 (카드번호, 고객명, 생년월일, 전화번호)
                  <ul>
                    <li>※ 비씨카드: IP 포함</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>건당 1만원 초과 전자금융거래 기록</li>
                    <li>- 보존 이유: 전자금융거래법</li>
                    <li>- 보존 기간: 5년</li>
                    <li>건당 1만원 이하 전자금융거래 기록</li>
                    <li>- 보존 이유: 전자금융거래법</li>
                    <li>- 보존 기간: 1년</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <ul>
                    <li>- 금융결제원</li>
                    <li>
                      -
                      정보/광주/수민/기업/농협/대구/부산/산업/새마을금고/수협/신협/신한/우리/우체국/전북/제주/KEB하나/씨티/SC제일은행/산림조합/카카오뱅크/케이뱅크(주)
                    </li>
                    <li>
                      -
                      유안타/현대/미래에셋/한투/코리츠지/하이투자/HMC투자/SK/대신/한대투/신한금융/동부/유진투자/메리츠/산업/삼성/한화/대우증권
                    </li>
                    <li>- 쿠콘</li>
                  </ul>
                </td>
                <td>계좌이체 결제</td>
                <td>
                  가맹점명 (계좌번호, 고객명, 생년월일)
                  <ul>
                    <li>※ 금융결제원 주민번호 미제공</li>
                    <li>※ 공인인증서 서명 검증 및 신원확인 시 주민번호 제공</li>
                  </ul>
                </td>
                <td>-</td>
              </tr>
              <tr>
                <td>
                  (주)카카오페이, (주)엔에스에이치정보통신, 웨이브씨엔에이코리아(주), 롯데멤버스(주),
                  케이뱅크(주), 삼성전자(주), (주)바바리퍼블리카
                </td>
                <td>간편결제</td>
                <td>가맹점명 (전화번호, 성명)</td>
                <td>-</td>
              </tr>
              <tr>
                <td>
                  국민, 농협, 우리, 신한, KEB하나, 기업, 우체국, 부산, 경남, 대구, 수협, 씨티, 삼성증권, SC,
                  광주, 전북
                </td>
                <td>가상계좌 결제</td>
                <td>가맹점명 (가상 계좌번호)</td>
                <td>-</td>
              </tr>
              <tr>
                <td>(주)SKT, (주)KT, (주)LGU+, MVNO사업자, (주)모빌리언스, (주)다날</td>
                <td>휴대폰 결제</td>
                <td>가맹점명 (휴대폰 번호, 생년월일, 성명, IP)</td>
                <td>-</td>
              </tr>
              <tr>
                <td>한국문화진흥, 베이조크엔라이프, 페이토피아이엔에이</td>
                <td>상품권 결제, 부정결제 확인</td>
                <td>가맹점명 (구매자 ID, 비밀번호, 상품권번호)</td>
                <td>-</td>
              </tr>
              <tr>
                <td>(주)아이앤플아이</td>
                <td>MDI필터링</td>
                <td>가맹점명 (ID, 비밀번호)</td>
                <td>-</td>
              </tr>
              <tr>
                <td>(주)SK플래닛, GS넥스테이션주식회사, 삼성전자, 롯데멤버스</td>
                <td>포인트 결제</td>
                <td>가맹점명 (포인트 카드번호, 카드비밀번호, 고객명 등)</td>
                <td>-</td>
              </tr>
              <tr>
                <td>금융결제원, KEB하나은행, 삼성전자, 주식회사 신세계아이앤씨</td>
                <td>전자지갑 결제</td>
                <td>가맹점명 (휴대폰 번호 등)</td>
                <td>-</td>
              </tr>
              <tr>
                <td>VISA, MASTER, JCB, AMEX, Diners, unionpay, 밴딜라비아, 댄젤트</td>
                <td>해외카드 (글로벌 서비스 포함)</td>
                <td>가맹점명 (카드번호, 고객명, 생년월일, 전화번호)</td>
                <td>-</td>
              </tr>
              <tr>
                <td>국세청</td>
                <td>현금영수증 발행</td>
                <td>가맹점명 (주민번호, 휴대폰번호, 고객명 등)</td>
                <td>-</td>
              </tr>
              <tr>
                <td>SKT, KT, LGU+, KG모빌리언스</td>
                <td>본인 확인 인증</td>
                <td>성명, 생년월일, 성별, 휴대폰번호, 내/외국인 식별정보, CI, DI</td>
                <td>-</td>
              </tr>
              <tr>
                <td>(주)페이콕</td>
                <td>광학문자인식 (OCR)</td>
                <td>카드번호, 카드유효기간</td>
                <td>-</td>
              </tr>
            </tbody>
          </table>
        </section>
        <section class="${klass.mb16}">
          <p>
            2. 개인정보 처리 위탁을 하는 업무의 내용 및 수탁자 회사는 정보주체의 개인정보가 안전하게 처리될 수
            있도록 개인정보처리 수탁자를 관리·감독하고, 홈페이지에 공개하고 있습니다.
          </p>
        </section>
        <section class="${klass.mb16}">
          <table class="${klass.terms_table}">
            <thead>
              <tr>
                <th>개인정보 취급 위탁</th>
                <th>업무의 내용</th>
                <th>개인정보 보유 및 이용기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>(주)굿스플로</td>
                <td>배송정보 안내서비스 제공</td>
                <td>위탁 업무 종료 시까지</td>
              </tr>
              <tr>
                <td>(주)케이에스한국고용정보</td>
                <td>고객지원 및 고객 고충처리<br />전자결제 과정의 기술지원</td>
                <td>위탁 업무 종료 시까지</td>
              </tr>
            </tbody>
          </table>
        </section>
        <section>
          <p>3. 개인정보의 제3자 제공 및 위탁 거부</p>
        </section>
        <section>
          <p>
            이용자는 개인정보의 제3자 제공 및 위탁 동의를 거부할 수 있습니다. 단, 동의를 거부하는 경우 본
            서비스 결제가 정상적으로 이루어질 수 없음을 알려드립니다.
          </p>
        </section>
      </div>
    `;
  }
}

export const createOnClickPersonalInfoOutsourcing = (parent_selector?: string) =>
  createAgreeModal({
    title: '개인정보 제공 및 위탁안내',
    body: new PersonalInfoOutsourcingTerms({}),
    body_klass: `${PersonalInfoOutsourcingTerms}`,
    style_klass: 'terms_modal_style terms_style',
    is_bottom_sheet: false,
    parent_selector,
  });
